import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: {},
  loading: false,
  inventoryLoading: false,
  storeInventoryLoading: false,
  error: null,
  skuInfo: {},
  deliveryDate: null,
  inventory: [],
  storeInventory: [],
  farfetchProductData: {},
  farfetchError: null,
};

const prepareProductDetails = (rawProductData) => {
  const { customization } = rawProductData;

  // Identify status of "In store only" flag
  // According to  provided data payload in https://neimanmarcus.atlassian.net/browse/OSP-4268
  let inStoreOnly = false;

  if (customization) {
    const { customizationOrder = [], customizationOptions = [] } = customization;
    const findBVDGroup = ({ group }) => group === 'BVD';
    inStoreOnly = customizationOrder.some(findBVDGroup) && customizationOptions.some(findBVDGroup);
  }
  const formatParentheticalCharge = (charge = 0) => (charge % 1 !== 0 ? charge.toFixed(2) : charge);

  return {
    inStoreOnly,
    ...rawProductData,
    ...(rawProductData.parentheticalCharge && {
      parentheticalCharge: formatParentheticalCharge(rawProductData.parentheticalCharge),
    }),
  };
};

const mapSkuInfoDropShip = (skuInfo = {}) => {
  const { dropShip } = skuInfo;

  return dropShip ? { ...skuInfo, dropShip: Boolean(dropShip === 'Y') } : skuInfo;
};

const productDetails = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PRODUCT_DETAILS_LOADING:
      return {
        ...INITIAL_STATE,
        loading: true,
      };
    case actions.PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        data: prepareProductDetails(payload),
        loading: false,
        skuInfo: mapSkuInfoDropShip(payload.skuInfo),
      };
    case actions.PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.PRODUCT_DETAILS_SET_SKU_INFO:
      return {
        ...state,
        skuInfo: payload || {},
        loading: false,
      };
    case actions.PRODUCT_DETAILS_SET_DELIVERY_DATE:
      return {
        ...state,
        deliveryDate: payload,
      };
    case actions.PRODUCT_INVENTORY_LOADING:
      return {
        ...state,
        inventory: [],
        inventoryLoading: true,
      };
    case actions.PRODUCT_INVENTORY_SUCCESS:
      return {
        ...state,
        inventory: payload,
        inventoryLoading: false,
      };
    case actions.PRODUCT_INVENTORY_ERROR:
      return {
        ...state,
        error: payload,
        inventoryLoading: false,
      };
    case actions.PRODUCT_STORE_INVENTORY_LOADING:
      return {
        ...state,
        storeInventory: [],
        loading: true,
        storeInventoryLoading: true,
      };
    case actions.PRODUCT_STORE_INVENTORY_SUCCESS:
      return {
        ...state,
        storeInventory: payload,
        loading: false,
        storeInventoryLoading: false,
      };
    case actions.PRODUCT_STORE_INVENTORY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        storeInventoryLoading: false,
      };
    case actions.PRODUCT_INVENTORY_STORE_RESET:
      return {
        ...state,
        inventory: [],
        storeInventory: [],
        farfetchProductData: {},
        loading: false,
        inventoryLoading: false,
        storeInventoryLoading: false,
      };
    case actions.PRODUCT_DETAILS_FARFETCH_LOADING:
      return {
        ...state,
        loading: true,
        farfetchError: null,
        farfetchProductData: {},
      };
    case actions.PRODUCT_DETAILS_FARFETCH_SUCCESS:
      return {
        ...state,
        farfetchProductData: prepareProductDetails(payload),
        loading: false,
        skuInfo: mapSkuInfoDropShip(payload.skuInfo),
      };
    case actions.PRODUCT_DETAILS_FARFETCH_ERROR:
      return {
        ...state,
        farfetchError: payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default productDetails;
